import React from 'react';
import { OpModal } from 'components/customAntd/DLS/OpModal/OpModal';
import { List, Typography } from 'antd';
import { OpButton } from 'components/customAntd/DLS/OpButton/OpButton';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

interface ExternalRedFlagDetailsModalProps {
    open: boolean;
    onClose: () => void;
    record: any;
}

const ExternalRedFlagDetailsModal: React.FC<ExternalRedFlagDetailsModalProps> = ({
    open,
    onClose,
    record
}) => {
    const { t } = useTranslation();

    const formatDate = (dateStr: string) => {
        if (!dateStr) return null;
        try {
            return dateStr.length === 8
                ? dateStr.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3') // e.g. 19960600 will be converted to 1996-06-00
                : dateStr;
        } catch {
            return null;
        }
    };

    const isValidValue = (value: any) => value !== null && value !== undefined && value !== '';

    const profileData = [
        { label: t('visitors.externalRedFlag.modal.fields.firstName'), value: record?.person?.first_name },
        { label: t('visitors.externalRedFlag.modal.fields.lastName'), value: record?.person?.last_name },
        { label: t('visitors.externalRedFlag.modal.fields.middleName'), value: record?.person?.middle_name },
        { label: t('visitors.externalRedFlag.modal.fields.gender'), value: record?.person?.gender },
        { label: t('visitors.externalRedFlag.modal.fields.dob'), value: formatDate(record?.person?.dob) },
    ].filter(item => isValidValue(item.value));

    const recordDetails = [
        { label: t('visitors.externalRedFlag.modal.fields.category'), value: record?.category },
        { label: t('visitors.externalRedFlag.modal.fields.date'), value: formatDate(record?.cases?.[0]?.arrest_date) },
        { label: t('visitors.externalRedFlag.modal.fields.type'), value: record?.cases?.[0]?.charges?.[0]?.type },
        { label: t('visitors.externalRedFlag.modal.fields.source'), value: record?.source?.name },
        { label: t('visitors.externalRedFlag.modal.fields.sourceCounty'), value: record?.source?.county },
        { label: t('visitors.externalRedFlag.modal.fields.sourceState'), value: record?.source?.state },
    ].filter(item => isValidValue(item.value));


    return (
        <OpModal
            title={t('visitors.externalRedFlag.modal.title')}
            open={open}
            footer={[
                <OpButton key="close" type="primary" onClick={onClose}>
                    {t('visitors.externalRedFlag.modal.close')}
                </OpButton>,
            ]}
            onCancel={onClose}
            width={700}
            okText={t('visitors.externalRedFlag.modal.close')}
        >
            <div style={{ maxHeight: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
                {profileData.length > 0 && (
                    <>
                        <Title level={5} style={{ marginBottom: 16 }}>{t('visitors.externalRedFlag.modal.personalInfo')}</Title>
                        <List
                            bordered
                            dataSource={profileData}
                            renderItem={(item) => (
                                <List.Item>
                                    <Text strong>{item.label}:</Text> {item.value}
                                </List.Item>
                            )}
                        />
                    </>
                )}

                {recordDetails.length > 0 && (
                    <>
                        <Title level={5} style={{ margin: '24px 0 16px' }}>{t('visitors.externalRedFlag.modal.recordDetails')}</Title>
                        <List
                            bordered
                            dataSource={recordDetails}
                            renderItem={(item) => (
                                <List.Item>
                                    <Text strong>{item.label}:</Text> {item.value}
                                </List.Item>
                            )}
                        />
                    </>
                )}

                {
                    record?.person?.photo_urls?.length > 0 && (
                        <>
                            <Title level={5} style={{ margin: '24px 0 16px' }}>{t('visitors.externalRedFlag.modal.photoUrls')}</Title>
                            <List
                                bordered
                                dataSource={record?.person?.photo_urls}
                                renderItem={(url: string) => (
                                    <List.Item>
                                        <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
                                    </List.Item>
                                )}

                            />
                        </>
                    )}
            </div >
        </OpModal >
    );
};

export default ExternalRedFlagDetailsModal;